import * as React from 'react';
import useTtdSettings from './useTtdSettings';
import useConversionPixel from './useConversionPixel';
import { pushAnalyticsEvent } from '../../lib/trackAnalyticsEvent';

export default function useTrackEmailSignupForCareers(): () => void {
    const { emailSignupForCareersEventId } = useTtdSettings();
    const renderPixel = useConversionPixel();

    return React.useCallback(() => {
        pushAnalyticsEvent('careers_email_signup', {
            event_category: 'engagement',
            ttd_event_id: emailSignupForCareersEventId,
        });

        if (emailSignupForCareersEventId) {
            renderPixel({
                ct: emailSignupForCareersEventId,
                alt: 'ttd email signup for careers',
            });
        }
    }, [renderPixel, emailSignupForCareersEventId]);
}
